import React from "react";

import CitiesComponent from "./CitiesComponent";

const App = () => {
  return (
    <div>
      <CitiesComponent />
    </div>
  );
};

export default App;
